import React from 'react';
import Header from './Header';
import Intro from '../Intro/Intro';
import s from './Layout.scss';

class Layout extends React.Component {

  /** Class initialization */
  constructor() {
    super();

    this.defaultState = { content: false };
    this.state = { ...this.defaultState };
  }

  componentDidMount() {
    // window.componentHandler.upgradeElement(this.refs.root);
  }

  componentWillUnmount() {
    // window.componentHandler.downgradeElements(this.refs.root);
  }

  setContentView = (show) => {
    this.setState({ ...this.state, content: !!show });
  }

  render() {
    return (
      <div ref="root" className={`${s.wrapper} ${(this.state.content ? s.show : '')}`}>
        <div className={s.intro}><Intro setContentView={this.setContentView} /></div>
        <div className={s.header}><Header /></div>
        <main {...this.props} className={s.content} />
      </div>
    );
  }
}

export default Layout;



/** WEBPACK FOOTER **
 ** ./components/Layout/Layout.js
 **/